import type { PropsWithChildren } from 'react';
import loadable from '@loadable/component';
import type { PageFC } from '@salesforce/pwa-kit-react-sdk';
import { Layout } from '../../components/layout/Layout';
import { AccountSkeletons } from './components/skeletons/AccountSkeletons';

const Account = loadable(() => import('./Account'));

const AccountLazy: PageFC<PropsWithChildren> = (props) => (
    <Layout className="bg-slt-grey-150">
        <Account {...props} fallback={<AccountSkeletons />} />
    </Layout>
);

export { AccountLazy };
